import React from "react"
import {Table} from "antd"


const ClubMemberFindTrackRound = ({loading, datasource}) => {
    const columns = [
        {
            title: 'id',
            dataIndex: 'id',
            key: 'id',
        }, {
            title: '账号',
            dataIndex: 'account',
            key: 'account',
        }, {
            title: '用户',
            dataIndex: 'nickname',
            key: 'nickname',
        }, {
            title: '球台',
            dataIndex: 'table_name',
            key: 'table_name',
        }, {
            title: '开始时间',
            dataIndex: 'start_time',
            key: 'start_time',
        }, {
            title: '结束时间',
            dataIndex: 'time',
            key: 'time',
        }, {
            title: '数量',
            dataIndex: 'num',
            key: 'num',
        }, {
            title: '总金额',
            dataIndex: 'price',
            key: 'price',
        }, {
            title: '单价',
            dataIndex: 'uprice',
            key: 'uprice',
        }, {
            title: '奖金',
            dataIndex: 'profit',
            key: 'profit',
        },
    ]

    return (
        <div style={{padding:16}}>
            <Table
                columns={columns}
                dataSource={datasource}
                loading={loading}
                title={() => '回合消费'}
            />
        </div>
    )
}

export default ClubMemberFindTrackRound


// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/component/ClubMemberFind/component/ClubMemberFindTrack/component/ClubMemberFindTrackRound.js